export default __webpack_public_path__ + "static/media/ce-rosetta-shell.7be31dba.png";